<template>
    <input
        type="file"
        ref="file"
        :required="item.required == '1'"
        :style="inputStyle"
        accept=".jpg, .png, .pdf, .jpeg, .jfif, .webp"
        @change="handleFileUpload()"
        style="width: 100%"
    />
</template>

<script>
export default {
    name: "FileUpload",
    props: ["value", "item", "inputStyle"],
    data() {
        return {
            file: this.value,
        };
    },
    methods: {
        handleFileUpload() {
            const allowedExtensions = [
                    "jpg",
                    "png",
                    "PNG",
                    "webp",
                    "jfif",
                    "jpeg",
                    "pdf",
                ],
                sizeLimit = 10000000; // 10 megabyte

            let file = this.$refs.file.files[0];

            // destructuring file name and size from file object
            const { name: fileName, size: fileSize } = file;

            /*
             * if filename is apple.png, we split the string to get ["apple","png"]
             * then apply the pop() method to return the file extension
             */
            const fileExtension = fileName.split(".").pop();

            let errorMessage = "";

            /*
             *	check if the extension of the uploaded file is included
             *	in our array of allowed file extensions
             */
            if (!allowedExtensions.includes(fileExtension)) {
                errorMessage = this.$t("form.error.invalid-upload-ext");
            } else if (fileSize > sizeLimit) {
                errorMessage = this.$t("form.error.invalid-upload-size");
            }

            if (errorMessage) {
                this.$emit("error", errorMessage);
                this.$emit("input", null);

                this.$refs.file.value = null;
            } else {
                this.$emit("error", null);
                this.$emit("input", file);
            }
        },
    },
};
</script>

<style>
</style>